var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandBunnerLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\r\n\t\t\tCreated with Pixso.\r\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 9.97241C1 7.59277 1.89551 5.31079 3.48962 3.62817C5.08362 1.94556 7.24585 1 9.50012 1C11.7545 1 13.9164 1.94531 15.5105 3.62793C17.1045 5.31079 18 7.59326 18 9.9729C18 16.2612 12.8462 21.4609 10.5649 23.4546C10.2372 23.741 10.0731 23.884 9.8291 23.9573C9.6394 24.0142 9.36035 24.0142 9.17065 23.9573C8.927 23.884 8.76184 23.7397 8.4353 23.4543C6.15405 21.4607 1 16.2605 1 9.97241ZM7.07141 8.77637C7.07141 7.34473 8.15881 6.18408 9.5 6.18408C10.8413 6.18408 11.9286 7.34473 11.9286 8.77637C11.9286 10.2078 10.8413 11.3684 9.5 11.3684C8.15881 11.3684 7.07141 10.2078 7.07141 8.77637Z",
    stroke: "#FFBB4D",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandBunnerLocationIcon);
export default __webpack_public_path__ + "static/media/brand-bunner-location-icon.7e7a792316bc9700e2acebf40d45edc2.svg";
export { ForwardRef as ReactComponent };